import { ProfessionIcon } from './profession-icon';

export const IconGardener = () => (
  <ProfessionIcon bg="#E8F5E9">
    <svg width="28" height="28" viewBox="0 0 24 24" fill="none">
      <path
        d="M12 22V12"
        stroke="#4CAF50"
        strokeWidth="1.8"
        strokeLinecap="round"
      />
      <path
        d="M8 12c0-4 4-8 4-8s4 4 4 8"
        stroke="#4CAF50"
        strokeWidth="1.8"
        strokeLinecap="round"
      />
      <path
        d="M5 16c0-3 3-5 7-4"
        stroke="#4CAF50"
        strokeWidth="1.8"
        strokeLinecap="round"
      />
      <path
        d="M19 16c0-3-3-5-7-4"
        stroke="#4CAF50"
        strokeWidth="1.8"
        strokeLinecap="round"
      />
    </svg>
  </ProfessionIcon>
);
